(function(api) {
	api.ZatvoriRad = ZatvoriRad;
	api.UgovorUpisiZaRad = UgovorUpisiZaRad;
	api.UpdateUgovorSati = UpdateUgovorSati;
	api.GetPonudaSFields = GetPonudaSFields;
	api.GetRacunSFields = GetRacunSFields;
	api.DohvatiDatotekuZaPotpisSC = DohvatiDatotekuZaPotpisSC;
	api.PotpisiCertilia = PotpisiCertilia;
	api.ZapisiAutoCertilia = ZapisiAutoCertilia;	

	function ZapisiAutoCertilia(iAutoCertilia) {
		return $.dsDirectCall({
            method: "ZapisiAutoCertilia",
            params: [iAutoCertilia]
        });
	}	

	function PotpisiCertilia(iGodina, iUgovor, mobilniPotpis, statusNovi, sNapomena) {
		return $.dsDirectCall({
            method: "PotpisiCertilia",
            params: [iGodina, iUgovor, mobilniPotpis, statusNovi, sNapomena]
        });
	}

	function DohvatiDatotekuZaPotpisSC(godina, ugovor, statusNovi) { 
		return $.dsDirectCall({
            method: "DohvatiDatotekuZaPotpisSC",
            params: [godina, ugovor, statusNovi]
        });
	}
	
	function ZatvoriRad(rad) {
		return $.dsDirectCall({ 
			method: "sc/ZatvoriRad",
			params: [rad]
		});
	}
	
	function UgovorUpisiZaRad(rad) {
		return $.dsDirectCall({ 
			method: "sc/UgovorUpisiZaRad",
			params: [rad]
		});
	}

	function UpdateUgovorSati(data, errorCB, doneCB) {
		return $.ajax({
	        url: kontorouter.getModulPath('ugovor/satiUpdate'),
	        type: "POST",
			data: data,
	        dataType: "json",
	    })
		.error(errorCB)
	    .done(doneCB);
	}
	
	function GetPonudaSFields(){
		return $.dsDirectCall({
			method: "GetPonudaSFields"
		});
	}
	function GetRacunSFields(){
		return $.dsDirectCall({
			method: "GetRacunSFields"
		});
	}
	
  	
} (konto.sc.api = {}));